import React, { useState, useEffect, useCallback } from 'react'

const API = ''

const FamilyImageModal = ({ family, onClose }) => {
    const [index, setIndex] = useState(0)
    const images = family.images || []

    useEffect(() => { setIndex(0) }, [family])

    const prev = useCallback(() => setIndex(i => (i - 1 + images.length) % images.length), [images.length])
    const next = useCallback(() => setIndex(i => (i + 1) % images.length), [images.length])

    useEffect(() => {
        const onKeyDown = (e) => {
            if (e.key === 'Escape') onClose()
            else if (e.key === 'ArrowLeft') prev()
            else if (e.key === 'ArrowRight') next()
        }
        document.addEventListener('keydown', onKeyDown)
        return () => document.removeEventListener('keydown', onKeyDown)
    }, [onClose, prev, next])

    return (
        <div className="pfc-family-modal-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label={family.name}>
            <div className="pfc-family-modal" onClick={(e) => e.stopPropagation()}>
                <button type="button" className="pfc-family-modal-close" onClick={onClose} aria-label="Close">✕</button>

                <div className="pfc-family-modal-slideshow">
                    {images.length > 0 ? (
                        <>
                            <img
                                src={`${API}${images[index].image_path}`}
                                alt={`${family.name} ${index + 1} of ${images.length}`}
                                className="pfc-family-modal-img"
                            />
                            {images.length > 1 && (
                                <>
                                    <button type="button" className="pfc-family-modal-arrow pfc-family-modal-arrow-left" onClick={prev} aria-label="Previous image">‹</button>
                                    <button type="button" className="pfc-family-modal-arrow pfc-family-modal-arrow-right" onClick={next} aria-label="Next image">›</button>
                                    <div className="pfc-family-modal-dots">
                                        {images.map((img, i) => (
                                            <button
                                                key={img.id}
                                                type="button"
                                                className={`pfc-family-modal-dot${i === index ? ' is-active' : ''}`}
                                                onClick={() => setIndex(i)}
                                                aria-label={`Show image ${i + 1}`}
                                            />
                                        ))}
                                    </div>
                                </>
                            )}
                        </>
                    ) : (
                        <div className="pfc-family-modal-placeholder">No images yet</div>
                    )}
                </div>

                <div className="pfc-family-modal-caption">
                    <h3 className="pfc-family-modal-title">{family.name}</h3>
                    <p className="pfc-family-modal-desc">{family.description}</p>
                </div>
            </div>
        </div>
    )
}

export default FamilyImageModal
